var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 23.2725C27.1855 23.2725 23.2728 27.1851 23.2728 31.9997C23.2728 36.8143 27.1855 40.727 32.0001 40.727C36.8147 40.727 40.7274 36.8143 40.7274 31.9997C40.7274 27.1851 36.8146 23.2725 32.0001 23.2725Z",
    fill: "#000632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 10.1816C17.4546 10.1816 5.03278 19.2288 0 31.9998C5.03278 44.7707 17.4546 53.818 32.0001 53.818C46.56 53.818 58.9674 44.7707 64.0001 31.9998C58.9674 19.2288 46.56 10.1816 32.0001 10.1816ZM32.0001 46.5452C23.971 46.5452 17.4546 40.0288 17.4546 31.9997C17.4546 23.9706 23.971 17.4543 32.0001 17.4543C40.0292 17.4543 46.5456 23.9707 46.5456 31.9998C46.5456 40.0289 40.0292 46.5452 32.0001 46.5452Z",
    fill: "#000632"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.094234895e954c564d13c16e2f5bd967.svg";
export { ForwardRef as ReactComponent };